import React, { useEffect, useState } from "react";
import {
  Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent,
  DrawerHeader, DrawerOverlay, Text, VStack,
} from "@chakra-ui/react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import { MdOutlineBedroomParent } from "react-icons/md";
import { IoFastFoodOutline } from "react-icons/io5";
import { useShowSidebar } from "../modules/context/showSidebarContext";

const navigationItems = [
  ["/dashboard", "Dashboard", FaHome],
  ["/printRegister", "Restaurant Info", FaHome],
  ["/table-register", "Table Registration", MdOutlineBedroomParent],
  ["/wine-register", "Wine Registration", MdOutlineBedroomParent],
  ["/category-register", "Wine Category Registration", MdOutlineBedroomParent],
  ["/foodcategory-register", "Food Category Registration", MdOutlineBedroomParent],
  ["/waiter-register", "Waiter Register", MdOutlineBedroomParent],
  ["/ncRegister", "NC Register", MdOutlineBedroomParent],
  ["/food-register", "Food-Item Registration", IoFastFoodOutline],
  ["/restaurant", "Restaurant Bill", IoFastFoodOutline],
  ["/summary", "Report Summary", IoFastFoodOutline],
];

const Sidebar = () => {
  const { showSidebar, isDesktop, closeSidebar } = useShowSidebar();
  const [data, setData] = useState([]);
  const customerId = localStorage.getItem("customerId");
  const location = useLocation();

  useEffect(() => {
    if (!customerId) return;
    let active = true;
    axios.get(`https://api.rcb.tdrsoftware.in/api/getPrintData/${customerId}`)
      .then((response) => {
        if (active) setData(response.data);
      })
      .catch(() => {
        if (active) setData([]);
      });
    return () => { active = false; };
  }, [customerId]);

  useEffect(() => {
    if (!isDesktop) closeSidebar();
  }, [location.pathname, isDesktop, closeSidebar]);

  const restaurantName = data.map((item) => item.name).filter(Boolean).join(" ");
  const navigation = (
    <VStack as="nav" aria-label="Restaurant navigation" spacing={1} align="stretch">
      {navigationItems.map(([path, label, Icon]) => (
        <Button
          key={path}
          as={Link}
          to={path}
          onClick={() => { if (!isDesktop) closeSidebar(); }}
          aria-current={location.pathname === path ? "page" : undefined}
          leftIcon={<Icon />}
          variant="ghost"
          justifyContent="flex-start"
          textAlign="left"
          whiteSpace="normal"
          height="auto"
          minHeight="44px"
          lineHeight="1.4"
          fontSize="sm"
          fontWeight="semibold"
          px={3}
          py={3}
          borderRadius="md"
          bg={location.pathname === path ? "tomato" : "transparent"}
          color={location.pathname === path ? "white" : "inherit"}
          _hover={{ bg: location.pathname === path ? "tomato" : "gray.100" }}
          sx={{ ".chakra-button__icon": { flexShrink: 0, marginRight: "10px" } }}
        >
          {label}
        </Button>
      ))}
    </VStack>
  );

  if (!isDesktop) {
    return (
      <Drawer isOpen={showSidebar} placement="left" onClose={closeSidebar} size="xs">
        <DrawerOverlay />
        <DrawerContent id="restaurant-sidebar" maxWidth="min(300px, 88vw)">
          <DrawerCloseButton aria-label="Close sidebar" />
          <DrawerHeader pr={12} fontSize="md" lineHeight="1.5" overflowWrap="anywhere">
            {restaurantName || "Restaurant menu"}
          </DrawerHeader>
          <DrawerBody px={3} pb={6}>{navigation}</DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  }

  if (!showSidebar) return null;
  return (
    <Box as="aside" id="restaurant-sidebar" bg="white" width="250px" flexShrink={0} px={3} py={5}>
      <Text mb={5} px={2} fontSize="md" fontWeight="bold" lineHeight="1.5" overflowWrap="anywhere">
        {restaurantName}
      </Text>
      {navigation}
    </Box>
  );
};

export default Sidebar;
